import { Text } from '@bpba/ui-components';
import { FC } from 'react';
import { SIMULATOR_WARNING_TEXT1, SIMULATOR_WARNING_TEXT2 } from '../constants/data';
import { GenericWarningContainer } from './GenericWarningContainer';

/**
 * Componente informativo que se muestra antes de confirmar
 * el envio del DEBIN a la cuenta bancaria del usuairo.
 */
export const SimulatorWarning: FC = () => {
  return (
    <GenericWarningContainer>
      <Text fontWeight={600}>{SIMULATOR_WARNING_TEXT1}</Text>
      <Text>{SIMULATOR_WARNING_TEXT2}</Text>
    </GenericWarningContainer>
  );
};
